﻿/* Customer theme variables */

$client-base: #199b37;
$client-dark: #037e00;
$client-light: #99cc00;
$client-highlight: #fce50d;

/* System specific colors */

$solid-green: $client-dark;
$solid-orange: #fe9900;
$solid-blue: #2b77e5;
$light-gray: #f6f6f6;
$light-aqua: #ebf5fb;
$light-green: #e9f7ef;
$light-orange: #fdf2e9;
$light-red: #fdedec;
$light-yellow: #f5f5e9;
$medium-gray: #e9ecef;

/* State colors */

$state-red: red; //#ff0000
$state-green: green; //#008000
$state-orange: orange; //#ffa500
$state-orangered: orangered;
$state-blue: dodgerblue; //#1e90ff
$state-gray: lightgray; //#d3d3d3

/* Bootstrap configuration */

$primary: $client-dark;
$font-size-base: 1rem;
$link-hover-decoration: none;
$enable-rounded: true;
$border-radius: 0;
$border-radius-lg: 0;
$btn-border-radius: 1.125rem;
$btn-focus-width: 0;
$btn-white-space: nowrap;
$input-font-weight: 500;
$input-focus-border-color: $client-light;
$input-placeholder-color: lightgray;
$form-group-margin-bottom: .75rem;
$table-cell-padding: .4rem;
$table-head-color: white;
$table-head-bg: $client-light;
$jumbotron-padding: 2rem;

@import '../../node_modules/bootstrap/scss/bootstrap';

/* Font Awesome configuration */

$fa-font-path: "./fonts";

@import "../../node_modules/@fortawesome/fontawesome-free/scss/fontawesome.scss";
@import "../../node_modules/@fortawesome/fontawesome-free/scss/regular.scss";
@import "../../node_modules/@fortawesome/fontawesome-free/scss/solid.scss";
